import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Spinner, OverlayTrigger, Tooltip, Toast, ToastContainer } from 'react-bootstrap';

import { EditionService } from '../../services/EditionService';
import { ClientService } from '../../services/ClientService';

import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import ClientDetails from '../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import './Clients.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import TagsFilter from "../../components/tags-filter/TagsFilter";
import { GlobalContext } from "../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../helper/Helper'
import TagsDialog from "../../components/tags-dialog/TagsDialog";

const Clients = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  let clientsParams = useRef({
    'start': 0,
    'limit': null,
    'search': null,
    'filters': null,
    'sort': null,
    'order': null,
    'fields': null
  });

  let openTab = useRef();

  const [globalError, setGlobalError] = useState()
  const [searchParams, setSearchParams] = useSearchParams();
  const [clients, setClients] = useState()
  const [isGetClientsLoading, setIsGetClientsLoading] = useState()
  const [isPDFLoading, setIsPDFLoading] = useState()
  const [sideWidth, setSideWidth] = useState()
  const [tableHeaders, setTableHeaders] = useState()
  const [checkedElementIdList, setCheckedElementIdList] = useState([])
  const [currentPagination, setCurrentPagination] = useState(1)
  const [isTableFilterVisible, setIsTableFilterVisible] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  const [currentClient, setCurrentClient] = useState()
  const [isClientEditing, setIsClientEditing] = useState(false)
  const [clientEditingId, setClientEditingId] = useState()
  const [tagsDialog, setTagsDialog] = useState({})

  const [tableRowElementActions] = useState([])
  const [clientElementActions] = useState([])

  let searchRef = useRef(null);

  useEffect(() => {
    if (grants) {
      granted(grants, "reglements.edit") && tableRowElementActions.push({ icon: "credit_card", title: "Ajouter un règlement", action: "addReglement" })

      granted(grants, "clients.edit") && tableRowElementActions.push({ icon: "edit", title: "Modifier le client", action: "editClient" })
      granted(grants, "clients.edit") && clientElementActions.push({ icon: "edit", title: "Modifier le client", action: "editClient" })

      granted(grants, "clients.remove") && tableRowElementActions.push({ icon: "delete_forever", title: "Supprimer", action: "removeClientDialog" })
      granted(grants, "clients.remove") && clientElementActions.push({ icon: "delete_forever", title: "Supprimer", action: "removeClientDialog" })

    }
  }, [grants]);

  useEffect(() => {
    if (globalContextLoaded) {
      searchParams.get('clientId') && getClient(searchParams.get('clientId'))
      setPreferences()
      getClients()
    }
  }, [globalContextLoaded]);

  function setPreferences() {
    setTableHeaders(formatTableHeadersFromPrefs(preferences.clients['tableHeaders'], parametres.clients['fieldsLabel']))
    clientsParams.current['sort'] = preferences.clients['tableSort']
    clientsParams.current['order'] = preferences.clients['tableOrder']
    clientsParams.current['limit'] = preferences.clients['tableCount'] || 5
    clientsParams.current['fields'] = Object.keys(preferences?.clients.tableHeaders).join(',')
  }

  function getClient(clientId) {
    ClientService.getClient(folderDetails?.dossier?._id, clientId).then(res => {
      if (res.status == 204) {
        setGlobalError({ statusText: "Le client demandé n'a pas été trouvé" })
      } else if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        changeCurrentClient(res.data.data)
        setIsClientEditing(false)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function getClients() {
    setCheckedElementIdList([])
    if (granted(grants, "clients.consult")) {
      setIsGetClientsLoading(true)
      ClientService.getClients(folderDetails?.dossier?._id, clientsParams.current).then(res => {
        setClients(res.data.data)
        setIsGetClientsLoading(false)
      }).catch(error => {
        setIsGetClientsLoading(false)
        setGlobalError(error)
      });
    }
  }

  function getClientsPDF(idList) {
    if (granted(grants, "clients.consult")) {
      !idList && setIsPDFLoading(true)
      let params = {
        'start': 0,
        'search': clientsParams.current.search,
        'sort': clientsParams.current.sort,
        'order': clientsParams.current.order,
        'filters': clientsParams.current.filters
      }

      if (idList) {
        params['clients'] = idList
      }

      EditionService.getListe(folderDetails?.dossier?._id, params, "clients", "pdf").then(res => {
        setIsPDFLoading(false)
        if (!res?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          getFile(res)
        }
      }).catch(error => {
        setIsPDFLoading(false)
        setGlobalError(error)
      });
    }
  }

  function removeClientList(clientIdList) {
    ClientService.removeClients(folderDetails?.dossier?._id, clientIdList).then(res => {
      setConfirmDialog({ show: false });
      getClients()
      changeCurrentClient()
      setSideWidth()
      uncheckElementList(clientIdList)
    }).catch(err => {
      setConfirmDialog({
        ...confirmDialog,
        dialogInfos: { ...confirmDialog.dialogInfos, error: err }
      })
    });
  }

  function uncheckElementList(idList) {
    let checkedElementIdListCopy = [...checkedElementIdList];
    idList.map(id => {
      let index = checkedElementIdListCopy.indexOf(id)
      if (index >= 0) {
        checkedElementIdListCopy.splice(index, 1)
      }
    })
    setCheckedElementIdList(checkedElementIdListCopy)
  }

  function saveTableHeadersPrefs(e) {
    const newHeadersObject = {}
    e.forEach(object => {
      newHeadersObject[object['dataTarget']] = { position: object['position'], hidden: object['hidden'] }
    });
    updatePreference({ ["tableHeaders"]: newHeadersObject })
  }

  function updatePreference(prefs) {
    PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['clients']: prefs } }).then(res => {
      getPreferences()
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeCurrentClient(client) {
    openTab.current = null
    client?._id ? setSearchParams({ clientId: client._id }) : setSearchParams(searchParams.delete('clientId'))
    setCurrentClient(client)
  }

  function changeTableHeaders(e) {
    setTableHeaders(e)
    saveTableHeadersPrefs(e)
  }

  function changePagination(p) {
    setCurrentPagination(p)
    clientsParams.current['start'] = (clientsParams.current.limit * p) - clientsParams.current.limit
    getClients()
  }

  function changeLimit(l) {
    clientsParams.current['limit'] = l
    updatePreference({ ["tableCount"]: l })
    changePagination(1)
  }

  let searchTimeOut;
  function changeSearchValue(value) {
    window.clearTimeout(searchTimeOut);
    searchTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      clientsParams.current['start'] = 0
      clientsParams.current['search'] = value ? value : ""
      searchRef.current.value = value ? value : ""
      getClients()
    }, 1000);
  }

  let filtersTimeOut;
  function changeFilters(f) {
    window.clearTimeout(filtersTimeOut);
    filtersTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      clientsParams.current['start'] = 0
      clientsParams.current['filters'] = f
      getClients()
    }, 1000);
  }

  function changeTagIdList(tagIdList) {
    let filtersCopy = { ...clientsParams?.current['filters'] }
    if (tagIdList.length > 0) {

      let tagArray = []
      tagIdList.map(tagId => {
        tagArray.push(tagId)
      })

      if (!filtersCopy[`filter[tags._id]`]) {
        filtersCopy[`filter[tags._id]`] = []
      }

      filtersCopy[`filter[tags._id]`] = [
        {
          "operation": "equal_to",
          "operator": "=",
          "value": tagArray.toString()
        }
      ]
      changeFilters(filtersCopy)
      setIsTableFilterVisible(true)
    } else {
      if (filtersCopy && filtersCopy[`filter[tags._id]`]) {
        delete filtersCopy[`filter[tags._id]`]
        changeFilters(filtersCopy)
      }
    }
  }

  function clearFilters() {
    setCurrentPagination(1)
    clientsParams.current['start'] = 0
    clientsParams.current['filters'] = null
    getClients()
    setIsTableFilterVisible(false)
  }

  function changeSortOrder(s, o) {
    clientsParams.current['sort'] = s
    clientsParams.current['order'] = o
    updatePreference({ ["tableSort"]: s, ["tableOrder"]: o })
    getClients()
  }

  function onClientSaved(clientId) {
    getClient(clientId)
    getClients()
  }

  function onTabChange() {
    getClients()
  }

  function closeSide() {
    setIsClientEditing(false)
    setCurrentClient()
  }

  function cancelEdition() {
    setIsClientEditing(false)
    !currentClient && setSideWidth()
  }

  function createNewClient() {
    setIsClientEditing(true)
    setClientEditingId()
  }

  function removeClientListDialog(clientIdList) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: `Supprimer ${clientIdList.length} client(s) ?`,
        description: 'Voulez vous supprimer les éléments sélectionnés ?',
        actionName: 'Supprimer la sélection',
        btnVariant: 'danger',
        element: clientIdList,
        error: false,
        confirmAction: 'removeClientList'
      }
    })
  }

  function setTags() {
    setTagsDialog({
      "show": true,
      "folderId": folderDetails?.dossier?._id,
      "documentIdList": checkedElementIdList
    })
  }

  function setCloseTagsDialog() {
    setTagsDialog({ show: false })
    getClients()
  }

  function removeClientDialog(client) {
    setConfirmDialog({
      show: true,
      dialogInfos: {
        title: client.nom,
        description: 'Voulez vous supprimer cet élément ?',
        actionName: 'Supprimer',
        btnVariant: 'danger',
        element: [client._id],
        error: false,
        confirmAction: 'removeClientList'
      }
    })
  }

  function editClient(client) {
    setIsClientEditing(true)
    setClientEditingId(client._id)
  }

  function addReglement(client) {
    openTab.current = "reglements"
    client?._id ? setSearchParams({ clientId: client._id }) : setSearchParams(searchParams.delete('clientId'))
    setCurrentClient(client)
  }

  /* const divRef = useRef(null); */
  
  return (
    <Container /* ref={divRef} */ fluid id="Clients" className="py-4">

      <div className="pb-2 d-flex align-items-center justify-content-between">
        <h4 className="m-0">Clients</h4>
        {granted(grants, "clients.edit") &&
          <Button variant="primary" className="ms-2" onClick={() => createNewClient()}>Créer un client</Button>
        }
      </div>

      <ErrorManager error={globalError} fixed="true" />

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <TagsDialog documentIdList={tagsDialog.documentIdList} documentType={"clients"} folderId={tagsDialog.folderId} show={tagsDialog.show} setCloseModal={setCloseTagsDialog} />

      <Row>

        <Col xs="12">
          <Row className="mb-4 gx-2">
            {granted(grants, "clients.consult") ?
              <>
                <Col sm="12" md="3" className="mb-2 mb-md-0">
                  <InputGroup className="w-100">
                    <i className="material-icons input-icon text-gray-400">search</i>
                    <FormControl
                      className="input-icon-space rounded-start"
                      placeholder="Recherche globale"
                      type="text"
                      onChange={e => changeSearchValue(e.target.value)}
                      ref={searchRef}
                    />
                    {clientsParams.current['search'] &&
                      <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                        <i className="material-icons i-lg">clear</i>
                      </Button>
                    }
                  </InputGroup>
                </Col>
                <Col sm="12" md="auto" className="d-flex mb-2 mb-md-0">
                  <InputGroup className="me-2 w-auto">
                    <TagsFilter btnClassName="rounded-end-0" btnTitle="Filtrer par tags" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={clientsParams?.current['filters']} />
                    {!clientsParams.current.filters &&
                      <OverlayTrigger placement="right" delay={{ show: 800 }} overlay={<Tooltip>Filtres de recherche</Tooltip>}>
                        <Button variant="secondary" onClick={() => setIsTableFilterVisible(!isTableFilterVisible)}>
                          <i className="material-icons i-lg">filter_alt</i>
                        </Button>
                      </OverlayTrigger>
                    }
                    {clientsParams.current.filters &&
                      <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                        Suppr. les filtres
                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                      </Button>
                    }
                  </InputGroup>
                  <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                </Col>
                <Col sm="12" md="auto">
                  <Button disabled={isPDFLoading} variant="secondary" className="me-2" onClick={() => getClientsPDF()}>
                    {!isPDFLoading && <i className="material-icons i-lg float-start me-2">print</i>}
                    {isPDFLoading && <Spinner animation="border" size="sm" className="me-2" />}
                    Imprimer la liste <span className="badge rounded-pill text-bg-light">{clients?.total}</span>
                  </Button>
                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block">
                      <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {/* <Dropdown.Item onClick={() => setCheckedElementIdList([])}>Tout désélectionner</Dropdown.Item> */}
                        <Dropdown.Item onClick={() => setTags()}>Tags</Dropdown.Item>
                        {granted(grants, "clients.remove") &&
                          <>
                            <Dropdown.Item onClick={() => getClientsPDF(checkedElementIdList)}>Imprimer la liste sélectionnée</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-danger" onClick={() => removeClientListDialog(checkedElementIdList)}>Supprimer</Dropdown.Item>
                          </>
                        }
                      </Dropdown.Menu>
                    </Dropdown>
                  }
                </Col>

              </>
              :
              <Col>
                <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
              </Col>
            }
          </Row>

          {granted(grants, "clients.consult") &&
            <Row className="mt-3">
              <Col xs="12">
                <div className="bg-white rounded border">
                  <DynamicTable
                    isDataLoading={isGetClientsLoading}
                    elementActions={tableRowElementActions}
                    setElementAction={(a, e) => eval(a)(e)}
                    sideWidth={sideWidth}
                    tableHeaders={tableHeaders}
                    tableDataList={clients?.clients}
                    currentElement={currentClient}
                    changeCurrentElement={e => changeCurrentClient(e)}
                    checkedElementIdList={checkedElementIdList}
                    setCheckedElementIdList={e => setCheckedElementIdList(e)}
                    changeFilters={f => changeFilters(f)}
                    isTableFilterVisible={isTableFilterVisible}
                    changeSortOrder={(s, o) => changeSortOrder(s, o)}
                    params={clientsParams.current}
                  />
                  <Pagination className="m-3" itemsLength={clients?.total} elementsPerPage={clientsParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit showDefinePage changeLimit={l => changeLimit(l)} />
                </div>
              </Col>
            </Row>
          }

          {(currentClient || isClientEditing) &&
            <SideDetails
              editMode={isClientEditing}
              currentElement={isClientEditing ? null : { id: currentClient?._id, label: currentClient?.code, title: currentClient?.nom }}
              changeCurrentElement={e => changeCurrentClient(e)}
              setSideClose={closeSide}
              setSideCancel={cancelEdition}
              setSideWidth={e => setSideWidth(e)}
              detailsComponent={
                isClientEditing ?
                  <ClientEdition folderId={folderDetails?.dossier?._id} clientEditingId={clientEditingId} onSetSaved={c => onClientSaved(c)} />
                  :
                  <ClientDetails openTab={openTab.current} folderId={folderDetails?.dossier?._id} clientId={currentClient._id} elementActions={clientElementActions} setElementAction={(a, e) => eval(a)(e)} onTabChange={() => onTabChange()} />
              }
            />
          }

        </Col>
      </Row>

    </Container>

  );
}

export default Clients;